import { Skeleton } from "antd";
import React, { useState, useEffect } from "react";
import APIService from "../../services/APIService";
import { priceFormat, priceFormat1 } from "../../utils";
import Heading from "../Heading";

export default function TopBuyToday() {
  const [dataOrder, setDataOrder] = useState(["", "", "", "", ""]);

  async function getOrderList() {
    const RESULT = await APIService.getOrderList(1, 5);
    if (RESULT) {
      setDataOrder(RESULT.data);
    }
  }

  useEffect(() => {
    getOrderList();
  }, []);

  return dataOrder.length ? (
    <div className="w-full">
      <Heading
        title="Top đại lý/Npp mua hàng hôm nay"
        className="text-[#222222]"
        isShowButtonMore={false}
      ></Heading>
      <div className="w-full h-[5px] mt-3 bg-[#EBEBEB] mb-3">
        <div className="w-1/4 h-full rounded-full bg-[#119AE2]"></div>
      </div>
      <div className="flex gap-y-[10px] flex-col">
        {dataOrder.map((item, index) =>
          item.id ? (
            <div
              key={index}
              className={
                "flex py-3 px-2 font-semibold text-sm " +
                (index % 2 ? "bg-[#F3F3F3]" : "bg-[#E6F0F9]")
              }
            >
              <p className="text-[#222222]">{index + 1}</p>
              <p className="flex justify-center text-[#222222] flex-1">
                {item.order_code}
              </p>
              <p className="flex justify-center text-[#222222] flex-1">
                {priceFormat(parseFloat(item.amount))}
              </p>
              <p className="flex flex-1 text-[#222222] text-one-lines ">
                {item.name_store}
              </p>
            </div>
          ) : (
            <Skeleton.Button
              key={index}
              style={{
                height: 45,
              }}
              active
              block={true}
              size="large"
            />
          )
        )}
      </div>
    </div>
  ) : (
    <></>
  );
}
